import type { SizeSet } from '../diagnostics/group';
import type { CompileResult } from '../engine/types';
import type { Lang, Translate } from '../i18n';

/** Names the engine gives a pattern without sizes; the UI shows its own words for them. */
const ONE_SIZE = /^(taille unique|unique|one size|single size)$/i;

export function isOneSizeName(name: string): boolean {
  return ONE_SIZE.test(name.trim());
}

/** Display name of a size, in the UI language for the engine's "one size" default. */
export function sizeName(result: CompileResult | null, index: number, lang: Lang = 'fr'): string {
  const name = result?.document.sizes.find((s) => s.index === index)?.name ?? String(index + 1);
  if (isOneSizeName(name)) return lang === 'en' ? 'one size' : 'taille unique';
  return name;
}

export function sizesLabel(sizes: SizeSet, result: CompileResult | null, t: Translate, lang: Lang = 'fr'): string {
  if (sizes === 'all') return t('diag.allSizes');
  return sizes.map((i) => sizeName(result, i, lang)).join(', ');
}
